import { forwardRef, TextareaHTMLAttributes } from "react";
import { FieldLabel } from "@/components/FieldLabel";
import { Textarea } from "@/components/Textarea";

interface TextareaFormFieldProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  id: string;
  label: string;
  description?: string;
  required?: boolean;
  /** Shown in brackets after the label, e.g. "This is not going to be publicly available". */
  labelHint?: string;
  error?: string;
  /** Formatting bar — see Textarea's `richText`. */
  richText?: boolean;
}

/** Label + muted description + Textarea, matching the repeated question/textarea blocks in signup forms. */
export const TextareaFormField = forwardRef<HTMLTextAreaElement, TextareaFormFieldProps>(
  ({ id, label, description, required, labelHint, error, className, ...textareaProps }, ref) => (
    <div data-field className="flex flex-col gap-2">
      <FieldLabel required={required} optionalHint={labelHint} htmlFor={id}>
        {label}
      </FieldLabel>
      {description && (
        <p className="text-12 text-theme-text-secondary leading-4 -mt-1">{description}</p>
      )}
      <Textarea ref={ref} id={id} rows={4} className={className} error={error} {...textareaProps} />
    </div>
  ),
);

TextareaFormField.displayName = "TextareaFormField";
